import contextActionTypes from 'src/modules/shared/context/actionTypes';
import { navigateTo } from 'src/utils/router';
import { close } from 'src/modules/websockets/initWebsockets';

export default () => next => action => {
  const result = next(action);
  switch (action.type) {
    case contextActionTypes.LOGOUT_SUCCESS:
      close();
      navigateTo('/');
      break;
    case contextActionTypes.UPDATE_LANGUAGE_SUCCESS:
      // Reload the page
      window.scrollTo(0, 0);
      // TODO: try using router.replace() instead
      window.location.reload();
      break;
    default:
      break;
  }

  return result;
};
